module.exports = __webpack_public_path__ + "static/media/phone-ico.f2e59376.svg";